$.fn.randomHover = function() {
  let self = this
  trigger = self;

  if (self.closest('.over-wrapper').find('.over-trigger').length > 0) {
    trigger = self.closest('.over-wrapper').find('.over-trigger').eq(0);
  }

  function zeronum(num) {
    var str = num.toString();
    if (str.length < 2) { str = "0" + str; }
    return str;
  }

  trigger.on("mouseover", function() {
    if (self.find('.over-element').length == 0) {
      //var onblack = ["08", "11", "14", "17", "20", "23", "28", "34", "40"];
      var onred = ["01", "02", "03", "04", "05", "06", "07", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "35", "36", "37", "38", "39", "41"];
      if ($(this).closest('.header__main').length > 0) {
        over_class = "OVER_" + onred[Math.floor(Math.random() * onred.length)];
      } else {
        over_class = "OVER_" + zeronum(Math.floor(Math.random() * (41 - 1 + 1) + 1));
      }
      var over = $('<span>').addClass("over-element").addClass(over_class)
      self.prepend(over);
    }
  });

  trigger.on("mouseleave", function() {
    self.find(".over-element").remove();
  });

  // $("body").on("mouseenter", ".over-link", function() {
  //   var onblack = ["08", "11", "14", "17", "20", "23", "28", "34", "40"],
  //   if ($(this).parent().parent().parent().hasClass("fixed-footer__composition")) {
  //     over_class = "OVER_" + onblack[Math.floor(Math.random() * onblack.length)];
  //   }
  //   if (element.length == 0) { element = $(this).parent().find(".over-target"); }
  //   $(this).find("picture").css("background", "transparent");
  //   $(this).find("img").css("transition", "none");
  //   $(this).data("over-element", over);
  // }).on("mouseleave", ".over-link", function() {
  //   if ($(this).data("over-element")) {
  //   }
  // });


  return function() {
    return self
  }()
}
